(function() {
      let $ = window.jQuery;

      $('#homepage-popup').parent().addClass('pxs-newsletter-section');
      $('.pxs-newsletter-section').hide();

      // exit newsletter
      $(document).mouseup(function(e) {
          var container = $(".pxs-newsletter");

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
              $("#homepage-popup").parent().hide();
              $("#homepage-popup").parent().css("visibility", "hidden");
          }
      });
      
      $(".der-close-btn").on("click", function(){
          $("#homepage-popup").parent().hide();
          $("#homepage-popup").parent().css("visibility", "hidden");
      })
      
      // -----------------------------------------------------------------------------
      // show newsletter upon reaching 65% of the screen
      if ($("body").hasClass('template-index')){
        var scrollPercentage;
        window.addEventListener('scroll', function() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            var scrollPercentage = (scrollTop / scrollHeight) * 100;

            if(scrollPercentage >= 65){
              $('.pxs-newsletter-section').show();
            }
        });
      }

      // -----------------------------------------------------------------------------
      // product qty select dropdown onchange
      window.qtyChange = function() {
        var selectValue = document.getElementById("product-quantity-select").value;
        document.getElementById("qty__input").value = selectValue;

        var select = document.getElementById("product-quantity-select");

        const qtyInputContainer = document.getElementById('product-input-qty');
        const qtyInput = document.getElementById('qty__input');
        const svg = document.getElementById('product-qty-svg');
        
        if (selectValue === '10+') {
          select.style.background = 'red';
          select.style.visibility = 'hidden';
          svg.style.visibility = 'hidden';
          qtyInputContainer.classList.remove('hidden');
          qtyInput.value = 10;
        }
      }

      let window_width = window.innerWidth;

      if (window_width <= 900) {
          window.toggleContent = function(element) {
            // alert();
              var arrow = element.querySelector('.custom-arrow');
              var content = element.nextElementSibling;
  
              if (content.style.display === "none" || content.style.display === "") {
                  content.style.display = "block";
                  element.style.paddingBottom = '0';
                  arrow.classList.add('active');
              } else {
                  content.style.display = "none";
                  element.style.paddingBottom = '25px';
                  arrow.classList.remove('active');
              }
          }
      }
  
      // -----------------------------------------------------------------------------
      // custom sibling options. show color instead of image
      function processSwitches(data) {
        let swatchMap = {};
        
        data.colors.forEach(obj => {
          let key = Object.keys(obj)[0].toLowerCase();
          swatchMap[key] = obj[key];
        });

        document.querySelectorAll("[data-x-swatch]").forEach(element => {
          let swatchKey = element.getAttribute("data-x-swatch").toLowerCase();
          if (swatchMap[swatchKey] && swatchMap[swatchKey].startsWith("#")) {
            element.style.backgroundColor = swatchMap[swatchKey];
          }
        });
      }

      function loadSwatches() {
        fetch('https://cdn.shopify.com/s/files/1/0267/9111/6853/files/swatch_29Jan_1.json?v=1769665024')
          .then(response => response.json())
          .then(data => processSwitches(data))
          .catch(error => console.error("Error loading swatches:", error));
      }

      document.addEventListener("DOMContentLoaded", loadSwatches);

      // add mutation observer to catch dynamically added elements
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            // reload swatches if noeds are added
            loadSwatches();
          }
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });

      // sticky add to cart
      document.addEventListener("DOMContentLoaded", function () {
        const originalAddToCart = document.querySelector(".btn--add-to-cart");
        const stickyAddToCart = document.querySelector(".sticky-add-to-cart");
        const footer = document.querySelector("footer");
    
        function toggleStickyButton() {
          if (!originalAddToCart || !stickyAddToCart) return;
    
          const rect = originalAddToCart.getBoundingClientRect();
          const footerRect = footer ? footer.getBoundingClientRect() : null;
    
          const isOriginalVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          const isNearFooter = footerRect ? footerRect.top < window.innerHeight : false;
    
          if (isOriginalVisible || isNearFooter) {
            stickyAddToCart.style.display = "none";
          } else {
            stickyAddToCart.style.display = "flex";
          }
        }
    
        window.addEventListener("scroll", toggleStickyButton);
        window.addEventListener("resize", toggleStickyButton);
        toggleStickyButton(); 
      });
    
})();
